import escorredor1 from "../img/casa/escorredor-de-louca/img1.jpeg";
import escorredor2 from "../img/casa/escorredor-de-louca/img2.jpeg";
import escorredor3 from "../img/casa/escorredor-de-louca/img3.jpeg";
import escorredor4 from "../img/casa/escorredor-de-louca/img4.jpeg";
import escorredor5 from "../img/casa/escorredor-de-louca/img5.jpeg";
import escorredor6 from "../img/casa/escorredor-de-louca/img6.jpeg";
import garrafaLiq1 from "../img/casa/garrafa-liquidificador/img1.jpeg"
import garrafaLiq2 from "../img/casa/garrafa-liquidificador/img2.jpeg"
import garrafaLiq3 from "../img/casa/garrafa-liquidificador/img3.jpeg"
import garrafaLiq4 from "../img/casa/garrafa-liquidificador/img4.jpeg"
import limpFone1 from "../img/casa/limpador-de-fone-de-ouvido/img1.jpeg"
import limpFone2 from "../img/casa/limpador-de-fone-de-ouvido/img2.jpeg"
import limpFone3 from "../img/casa/limpador-de-fone-de-ouvido/img3.jpeg"
import limpFone4 from "../img/casa/limpador-de-fone-de-ouvido/img4.jpeg"
import limpFone5 from "../img/casa/limpador-de-fone-de-ouvido/img5.jpeg"
import frascoA1 from "../img/casa/frasco-de-ampulheta/img1.jpeg"
import frascoA2 from "../img/casa/frasco-de-ampulheta/img2.jpeg"
import frascoA3 from "../img/casa/frasco-de-ampulheta/img3.jpeg"
import frascoA4 from "../img/casa/frasco-de-ampulheta/img4.jpeg"
import mochila_uni1 from "../img/novidades/mochila-unicornio/img1.jpeg"
import mochila_uni2 from "../img/novidades/mochila-unicornio/img2.jpeg"
import mochila_uni3 from "../img/novidades/mochila-unicornio/img3.jpeg"
import mochila_uni4 from "../img/novidades/mochila-unicornio/img4.jpeg"
import mochila_uni5 from "../img/novidades/mochila-unicornio/img5.jpeg"
import sanduicheira_multi1 from "../img/novidades/sanduicheira-multi/img1.jpeg"
import sanduicheira_multi2 from "../img/novidades/sanduicheira-multi/img2.jpeg"
import sanduicheira_multi3 from "../img/novidades/sanduicheira-multi/img3.jpeg"
import sanduicheira_multi4 from "../img/novidades/sanduicheira-multi/img4.jpeg"
import sanduicheira_multi5 from "../img/novidades/sanduicheira-multi/img5.jpeg"


export const produtos = [
    {
        nome: "Escorredor de Louça Autossustentavel",
        img: [
            {
                alt: "escorredor com louças",
                src: escorredor1
            },
            {
                alt: "especificações do produto e indicação de 3 meses de garantia",
                src: escorredor2
            },
            {
                alt: "estrutura do produto",
                src: escorredor3
            },
            {
                alt: "como usar",
                src: escorredor4
            },
            {
                alt: "o produto sem louças",
                src: escorredor5
            },
            {
                alt: "instruções de uso e especificações finais",
                src: escorredor6
            }
        ],
        preco: "R$: 169,38",
        link_compra: "https://shope.ee/VhBHAH23I",
        link_video: "caminho do video",
        cupom: "Frete gratis acima de R$:10",
        fonte: "Shopee",
        tipo: "casa | bebe | hot",
        obs: "Pia de 63cm e garantia de 3 meses!"
        // feedbacks: [{ESPAÇO PARA FEEDBACKS DO SITE}]
    },
    {
        nome: "Kit de Limpeza com Escova de Microfibra Macia",
        img: [
            {
                alt: "texto alternativo 1",
                src: limpFone1
            },
            {
                alt: "texto alternativo 2",
                src: limpFone2
            },
            {
                alt: "texto alternativo 3",
                src: limpFone3
            },
            {
                alt: "texto alternativo 3",
                src: limpFone4
            },
            {
                alt: "texto alternativo 3",
                src: limpFone5
            }
        ],
        preco: "R$: 9,90",
        link_compra: "https://shope.ee/8zfjMrOHLa",
        cupom: "62% de desconto",
        fonte: "Shopee",
        obs: "Ótima avaliação!"
    },
    {
        nome: "Frasco de ampulheta para guardar conservas",
        img: [
            {
                alt: "texto alternativo 1",
                src: frascoA1
            },
            {
                alt: "texto alternativo 2",
                src: frascoA2
            },
            {
                alt: "texto alternativo 3",
                src: frascoA3
            },
            {
                alt: "texto alternativo 3",
                src: frascoA4
            }
        ],
        preco: "R$: 61,60",
        link_compra: "https://shope.ee/7UqvbAP7Yq",
        cupom: "Frete grátis acima de R$: 10",
        fonte: "Shopee",
        obs: "Produto com 51% de desconto!"
    },
]

export const novidades = [
    {
        nome: "Mochila Escolar 4 Cores Com Grande Capacidade À Prova D'água",
        img: [
            {
                alt: "produto",
                src: mochila_uni1
            },
            {
                alt: "especificações do produto",
                src: mochila_uni2
            },
            {
                alt: "estrutura do produto",
                src: mochila_uni3
            },
            {
                alt: "como usar",
                src: mochila_uni4
            },
            {
                alt: "o produto com uma criança",
                src: mochila_uni5
            },
        ],
        preco: "R$79,98 - R$88,88",
        link_compra: "https://shope.ee/7fATpErKAn",
        link_video: "caminho do video",
        cupom: "Desconto no frete dependendo da localização!",
        fonte: "Shopee",
        tipo: "casa | bebe | hot",
        obs: "Mochilas Femininas e Masculinas!"
        // feedbacks: [{ESPAÇO PARA FEEDBACKS DO SITE}]
    },
    {
        nome: "Garrafa Juicer Liquidificador Elétrico Portátil Recarregável",
        img: [
            {
                alt: "foto da peneira",
                src: garrafaLiq1
            },
            {
                alt: "texto alternativo 2",
                src: garrafaLiq2
            },
            {
                alt: "texto alternativo 3",
                src: garrafaLiq3
            },
            {
                alt: "texto alternativo 3",
                src: garrafaLiq4
            }
        ],
        preco: "R$:21,99 - R$:23,99",
        link_compra: "https://shope.ee/3feD4CIg60",
        cupom: "Frete grátis acima de R$: 10",
        fonte: "Shopee",
        obs: "COPO 350ml Mixer Shake Misturador"
    },
    {
        nome: "Sanduicheira multi funções Hamilton Beach 110V",
        img: [
            {
                alt: "foto da sanduicheira",
                src: sanduicheira_multi1
            },
            {
                alt: "foto da sanduicheira",
                src: sanduicheira_multi2
            },
            {
                alt: "foto da sanduicheira",
                src: sanduicheira_multi3
            },
            {
                alt: "foto da sanduicheira",
                src: sanduicheira_multi4
            },
            {
                alt: "foto da sanduicheira",
                src: sanduicheira_multi5
            }
        ],
        preco: "R$249,99",
        link_compra: "https://shope.ee/g0jjonIdE",
        cupom: "R$20,00 de desconto no frete com cupom",
        fonte: "Shopee",
        obs: "Dá para dividir em 3x SEM JUROS!"
    },
]